import { useTranslation } from 'react-i18next';

interface SignupInstitutionFieldProps {
  defaultInstitution: string;
}

// Single-option dropdown today (PRD 19 §4.2 default = 울산대학교병원).
// Kept as <select> so the contract is ready for multi-institution later.
export const SignupInstitutionField = ({ defaultInstitution }: SignupInstitutionFieldProps) => {
  const { t } = useTranslation('auth');

  return (
    <div className="signup-page__field">
      <label className="login-page__label" htmlFor="signupInstitution">
        {t('signup.fields.institution')}
      </label>
      <select
        id="signupInstitution"
        className="signup-page__select"
        defaultValue={defaultInstitution}
      >
        <option value={defaultInstitution}>{defaultInstitution}</option>
      </select>
    </div>
  );
};
